import { ViewPayroll } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { payrollStore } from '../../stores';

const ViewPayrollContainer = ({ closeModal }) => {
	const [monthPayroll, setMonthPayroll] = useState(false);
	const [payrollSummary, setPayrollSummary] = useState(false);
	const [prevPayBreakdown, setPrevPayBreakdown] = useState(false);

	const showMonthPayroll = () => {
		setMonthPayroll(true);
	};

	const showPayrollSummary = () => {
		setPayrollSummary(true);
		setMonthPayroll(false);
	};

	const showPrevPayBreakdown = () => {
		setMonthPayroll(false);
		setPrevPayBreakdown(true);
	};

	return (
		<ViewPayroll
			closeModal={closeModal}
			groupPayrollsList={payrollStore.groupPayrolls}
			monthPayroll={monthPayroll}
			showMonthPayroll={showMonthPayroll}
			showPayrollSummary={showPayrollSummary}
			payrollSummary={payrollSummary}
			prevPayBreakdown={prevPayBreakdown}
			showPrevPayBreakdown={showPrevPayBreakdown}
		/>
	);
};

export default observer(ViewPayrollContainer);
